var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBicycle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45.14 27.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M52.21,32.51a8.78,8.78,0,0,0-3.28.6l-5.48-8.84a1.69,1.69,0,0,0-1.44-.8H37.49a1.14,1.14,0,0,0-1.13,1.13v1.13a1.14,1.14,0,0,0,1.13,1.13h3.58l1,1.69h-8V27.42A1.13,1.13,0,0,0,33,26.3H26.8A1.72,1.72,0,0,0,25.07,28h0a1.69,1.69,0,0,0,1.69,1.66H30.2L28.13,33a9,9,0,1,0,5.45,11.55c.09-.26.17-.52.24-.79h3.67a1.71,1.71,0,0,0,1.44-.8L45,33.2l1,1.7a9,9,0,0,0-2.91,6.66,9.14,9.14,0,0,0,8.94,9,9,9,0,1,0,.13-18.06Zm-23,5.2a5.59,5.59,0,0,1,1.38,2.7H27.55Zm-4.15,9.48a5.65,5.65,0,0,1,0-11.3,6.22,6.22,0,0,1,1.21.13l-3.21,5.19a1.7,1.7,0,0,0,.56,2.34,1.72,1.72,0,0,0,.88.25h5.74A5.68,5.68,0,0,1,25.07,47.19Zm11.48-6.78H34a9,9,0,0,0-3-5.65l1.74-2.82h9l-5.24,8.47Zm15.32,6.76a5.64,5.64,0,0,1-4-9.31l3.14,5a1.13,1.13,0,0,0,1.56.36h0l.95-.6a1.12,1.12,0,0,0,.37-1.55h0l-3.14-5A5.65,5.65,0,1,1,53.57,47a5.75,5.75,0,0,1-1.7.17Z",
    transform: "translate(-16.04 -23.47)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBicycle);
export default __webpack_public_path__ + "static/media/bicycle.b68f228be34813a0297bcef9e2e87b56.svg";
export { ForwardRef as ReactComponent };